import { render, staticRenderFns } from "./AssessmentsResults.vue?vue&type=template&id=897113b4&"
import script from "./AssessmentsResults.vue?vue&type=script&lang=js&"
export * from "./AssessmentsResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports